moduleViewApp.factory("LibraryModel", [->
  (modules, partner, type) ->
    service =
      modules: modules
      libraryLoaded: false
      sortOrders: [
        { value: "created_at_desc", label: "js.library_view.sort_orders.created_at_desc" },
        { value: "created_at_asc", label: "js.library_view.sort_orders.created_at_asc" },
        { value: "name_asc", label: "js.library_view.sort_orders.name_asc" },
        { value: "name_desc", label: "js.library_view.sort_orders.name_desc" },
      ]
      moduleType: type
      privacyPublic: true
      privacyPrivate: true
      privacyCourse: true
      filterCreator: false
      filterCollaboration: partner?.meta?.role == "editor"
      filterEditor: false
      includeClones: true
      searchText: ""

      updateModules: (modules) ->
        service.modules = modules
        service.libraryLoaded = true

    service.sortOrder = service.sortOrders[0]
    service
])
